const IP = process.env.NODE_ENV === 'production' ? 'https://nomu.strategy-offsite-meeting.com/api' : 'http://192.168.1.32:8000/api';
// const IP = 'https://nomu.strategy-offsite-meeting.com/api';


export default IP;
